import React from 'react'
import { Wrap } from './forgotPassButton.style'

const ForgotPassButton = () => {
  return <Wrap to={'/reset-password-enter-email'}>Forgot your password?</Wrap>
}

export default ForgotPassButton
